import { useAsyncFunction, useFetchData } from '@va/util/hooks';
import { useCallback } from 'react';
import {
  CheckDNSInput,
  CreateSenderEmailInput,
  CustomDomainsApi,
  DNSRecord,
  GetTargetedDNSRecordsInput,
  ListCompanyDomainsByTypeInput,
  ListCompanyDomainsByTypeResponsePayload,
  ListDNSRecordsInput,
  ListDNSRecordsResponsePayload,
  ListSenderEmailsInput,
  ListSenderEmailsResponsePayload,
  ListWebsiteDomainsByTypeInput,
} from '.';
import {
  createSenderEmail,
  getTargetedDNSRecords,
  listCompanyDomainsByType,
  listSenderEmails,
  listWebsiteDomainsByType,
  sendDummyEmail,
  SendDummyEmailInput,
} from './custom-domains.api';

export const useListDNSRecords = (input: ListDNSRecordsInput | null) => {
  const fetcher = useCallback(async (_: string, input: ListDNSRecordsInput) => {
    const res = await CustomDomainsApi.listDNSRecords(input);
    return res.payload;
  }, []);
  return useFetchData<ListDNSRecordsResponsePayload>(
    input === null ? null : ['list-dns-records', input],
    undefined,
    undefined,
    fetcher,
  );
};

export const useListSenderEmails = (input: ListSenderEmailsInput | null) => {
  const fetcher = useCallback(async (_: string, input: ListSenderEmailsInput) => {
    const res = await listSenderEmails(input);
    return res.payload;
  }, []);
  return useFetchData<ListSenderEmailsResponsePayload>(
    input === null ? null : ['list-sender-emails', input],
    undefined,
    undefined,
    fetcher,
  );
};

export const useCreateSenderEmail = () => {
  const fetcher = useCallback(async (input: CreateSenderEmailInput) => {
    const res = await createSenderEmail(input);
    return res.payload;
  }, []);

  return useAsyncFunction(fetcher, { throwErrorBack: true });
};

export const useGetTargetedDNSRecords = (input: GetTargetedDNSRecordsInput | null) => {
  const fetcher = useCallback(async (_: string, input: GetTargetedDNSRecordsInput) => {
    const res = await getTargetedDNSRecords(input);
    return res.payload;
  }, []);
  return useFetchData<DNSRecord[]>(
    input === null ? null : ['get-targeted-dns-records', input],
    undefined,
    undefined,
    fetcher,
  );
};

export const useListCompanyDomainsByType = (input: ListCompanyDomainsByTypeInput | null) => {
  const fetcher = useCallback(async (_: string, input: ListCompanyDomainsByTypeInput) => {
    const res = await listCompanyDomainsByType(input);
    return res.payload;
  }, []);
  return useFetchData<ListCompanyDomainsByTypeResponsePayload>(
    input === null ? null : ['list-company-domains-by-type', input],
    undefined,
    undefined,
    fetcher,
  );
};

export const useListWebsiteDomainsByType = (input: ListWebsiteDomainsByTypeInput | null) => {
  const fetcher = useCallback(async (_: string, input: ListWebsiteDomainsByTypeInput) => {
    const res = await listWebsiteDomainsByType(input);
    return res.payload;
  }, []);
  return useFetchData<ListCompanyDomainsByTypeResponsePayload>(
    input === null ? null : ['list-website-domains-by-type', input],
    undefined,
    undefined,
    fetcher,
  );
};

export const useDNSCheck = () => {
  const fetcher = useCallback(async (input: CheckDNSInput) => {
    const res = await CustomDomainsApi.checkDNS(input);
    return res.payload;
  }, []);

  return useAsyncFunction(fetcher, { throwErrorBack: true });
};

export const useSendDummyEmail = () => {
  const fetcher = useCallback(async (input: SendDummyEmailInput) => {
    const res = await sendDummyEmail(input);
    return res.payload;
  }, []);

  return useAsyncFunction(fetcher, { throwErrorBack: true });
};
